module.exports = __webpack_public_path__ + "img/bottom-arrow.6192a9a7.png";